import React from 'react';
import ReactApexChart from 'react-apexcharts';

const Salesdonut = ({ value }) => {
    const series = [
        value?.total_booking_complete || 0,
        value?.total_booking_cancel || 0,
        value?.total_booking_expired || 0
    ];

    const options = {
        dataLabels: {
            enabled: false,
        },
        legend: {
            show: false
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '80%'
                }
            }
        },
        colors: ['#626ed4', '#02a499', '#f8b425'],
        labels: ['Completed', 'Cancelled', 'Expired']
    };

    return (
        <ReactApexChart
            options={options}
            series={series}
            type="donut"
            height="220"
            className="apex-charts"
        />
    );
};

export default Salesdonut;
